import { render, staticRenderFns } from "./BgManageTopbar.vue?vue&type=template&id=776d0454&scoped=true"
import script from "./BgManageTopbar.vue?vue&type=script&lang=js"
export * from "./BgManageTopbar.vue?vue&type=script&lang=js"
import style0 from "./BgManageTopbar.vue?vue&type=style&index=0&id=776d0454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d0454",
  null
  
)

export default component.exports